export const GENERIC_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "pm.me",
  "mail.com",
  "gmx.com",
  "gmx.net",
  "yandex.com",
  "yandex.ru",
  "zoho.com",
  "fastmail.com",
  "tutanota.com",
  "tutanota.de",
  "duck.com",
  "ymail.com",
  "rocketmail.com",
  "aim.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "live.co.uk",
  "outlook.co.uk",
  "yahoo.ca",
  "yahoo.com.au",
  "yahoo.fr",
  "yahoo.de",
  "gmx.de",
  "web.de",
  "t-online.de",
  "orange.fr",
  "free.fr",
  "laposte.net",
  "qq.com",
  "163.com",
  "126.com",
  "naver.com",
  "hanmail.net",
  "daum.net",
  "rediffmail.com",
  "privaterelay.appleid.com",
  "anonaddy.me",
  "simplelogin.com",
  "relay.firefox.com",
  "mozmail.com",
  "comcast.net",
  "sbcglobal.net",
  "verizon.net",
  "att.net",
  "bellsouth.net",
  "cox.net",
  "charter.net",
  "earthlink.net",
  "optonline.net",
  "rr.com",
  "roadrunner.com",
  "twc.com",
  "frontier.com",
  "frontiernet.net",
  "windstream.net",
  "centurylink.net",
  "embarqmail.com",
  "suddenlink.net",
  "mchsi.com",
  "cableone.net",
  "juno.com",
  "netzero.net",
  "shaw.ca",
  "telus.net",
  "sympatico.ca",
  "rogers.com",
  "btinternet.com",
  "sky.com",
  "virginmedia.com",
  "talktalk.net",
  "bigpond.com",
  "optusnet.com.au",
  "pacbell.net",
  "prodigy.net",
  "ameritech.net",
  "swbell.net",
  "flash.net",
  "nvbell.net",
  "wans.net",
  "snet.net",
  "hotmail.ca",
  "live.ca",
  "outlook.ca",
  "yahoo.com.mx",
  "hotmail.com.mx",
  "prodigy.net.mx",
  "protonmail.ch",
  "hey.com",
  "icloud.co",
  "mail.ru",
  "inbox.com",
  "usa.net",
  "netscape.net",
  "cfl.rr.com",
  "gmx.us",
  "zohomail.com",
]);

export function isGenericEmailDomain(email: string): boolean {
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  const labels = email.slice(at + 1).toLowerCase().trim().split(".");
  return labels.some((_label, index) => GENERIC_EMAIL_DOMAINS.has(labels.slice(index).join(".")));
}

export function extractEmailDomain(email: string): string | null {
  const at = email.lastIndexOf("@");
  if (at < 0) return null;
  const domain = email.slice(at + 1).toLowerCase().trim();
  return domain.length > 0 ? domain : null;
}
